// dev-requests-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{n} tentativas": "%{n} intentos",
    "Aguardando aprovação": "Esperando aprobación",
    "Aguardando migração": "Esperando migración",
    "Aguardando suporte": "Esperando soporte",
    "App": "App",
    "Aprovar pedido": "Aprobar pedido",
    "Aprovação pedida": "Aprobación solicitada",
    "Ações do dev": "Acciones del dev",
    "Branch": "Branch",
    "Bug": "Bug",
    "Cancelar este pedido?": "¿Cancelar este pedido?",
    "Cancelar pedido": "Cancelar pedido",
    "Causa": "Causa",
    "Comentar": "Comentar",
    "Comentário registrado.": "Comentario registrado.",
    "Commits": "Commits",
    "Como pedir uma mudança ou uma investigação ao desenvolvimento: escrever bem o pedido, urgente ou normal, responder dúvidas e fechar.": "Cómo pedir un cambio o una investigación al desarrollo: escribir bien el pedido, urgente o normal, responder dudas y cerrar.",
    "Confirmar migração?": "¿Confirmar migración?",
    "Copiado.": "Copiado.",
    "Copiar": "Copiar",
    "Código no develop": "Código en develop",
    "Deploy": "Deploy",
    "Deploy concluído": "Deploy concluido",
    "Deploy falhou": "Deploy falló",
    "Deploy iniciado": "Deploy iniciado",
    "Deploy manual": "Deploy manual",
    "Dev": "Dev",
    "Diff do schema (master..develop)": "Diff del schema (master..develop)",
    "Editar pedido ao dev": "Editar pedido al dev",
    "Em deploy": "En deploy",
    "Entregue. Confira e marque como resolvido, ou reabra com um comentário.": "Entregado. Verifique y márquelo como resuelto, o reábralo con un comentario.",
    "Enviado para produção. Falta o deploy terminar.": "Enviado a producción. Falta que termine el deploy.",
    "Enviar respostas": "Enviar respuestas",
    "Este pedido não pode mais ser editado.": "Este pedido ya no se puede editar.",
    "Evento": "Evento",
    "Execução": "Ejecución",
    "Execução do Claude": "Ejecución de Claude",
    "Execuções do Claude": "Ejecuciones de Claude",
    "Funcionalidade": "Funcionalidad",
    "Investigação": "Investigación",
    "Já migrei": "Ya migré",
    "Loja de apps": "Tienda de apps",
    "Marcar como resolvido?": "¿Marcar como resuelto?",
    "Migração confirmada": "Migración confirmada",
    "Migração confirmada. O pedido volta para a fila.": "Migración confirmada. El pedido vuelve a la cola.",
    "Migração pendente": "Migración pendiente",
    "Motivo (opcional)": "Motivo (opcional)",
    "Motivo do robô": "Motivo del robot",
    "Na fila. O robô pega o pedido em breve.": "En la cola. El robot toma el pedido pronto.",
    "Nenhum projeto ainda.": "Ningún proyecto todavía.",
    "Nenhuma ação do dev pendente.": "Ninguna acción del dev pendiente.",
    "No ar": "En producción",
    "No develop": "En develop",
    "Normal": "Normal",
    "Notas do dev": "Notas del dev",
    "Nova tentativa": "Nuevo intento",
    "Novo pedido ao dev": "Nuevo pedido al dev",
    "Nº": "N.º",
    "Não foi possível concluir a ação.": "No fue posible completar la acción.",
    "Não foi possível copiar.": "No fue posible copiar.",
    "O dev precisa rodar uma alteração no banco. Depois disso o pedido segue sozinho.": "El dev necesita ejecutar un cambio en la base. Después de eso el pedido sigue solo.",
    "O pedido precisa da aprovação do dev antes de seguir.": "El pedido necesita la aprobación del dev antes de seguir.",
    "O pedido volta para a fila e o deploy segue.": "El pedido vuelve a la cola y el deploy sigue.",
    "O que ainda não está certo?": "¿Qué todavía no está correcto?",
    "O que foi feito": "Qué se hizo",
    "O robô está trabalhando neste pedido.": "El robot está trabajando en este pedido.",
    "O robô não conseguiu concluir. O dev foi avisado.": "El robot no logró terminar. Se avisó al dev.",
    "O robô para de trabalhar nele.": "El robot deja de trabajar en él.",
    "O robô tem perguntas. Responda abaixo para ele continuar.": "El robot tiene preguntas. Responda abajo para que continúe.",
    "Observação (opcional)": "Observación (opcional)",
    "PR": "PR",
    "PR deploy": "PR deploy",
    "PR develop": "PR develop",
    "Pedido": "Pedido",
    "Pedido aprovado.": "Pedido aprobado.",
    "Pedido atualizado.": "Pedido actualizado.",
    "Pedido cancelado.": "Pedido cancelado.",
    "Pedido criado": "Pedido creado",
    "Pedido criado.": "Pedido creado.",
    "Pedido editado": "Pedido editado",
    "Pedido reaberto.": "Pedido reabierto.",
    "Pedido recusado.": "Pedido rechazado.",
    "Pedido resolvido.": "Pedido resuelto.",
    "Pedido volta para a fila.": "El pedido vuelve a la cola.",
    "Pedidos ao dev": "Pedidos al dev",
    "Perguntas do robô": "Preguntas del robot",
    "Precisa atualizar o app": "Necesita actualizar la app",
    "Precisa atualizar o app: não.": "Necesita actualizar la app: no.",
    "Precisa atualizar o app: sim.": "Necesita actualizar la app: sí.",
    "Projetos": "Proyectos",
    "Quem": "Quién",
    "Quem pediu": "Quién lo pidió",
    "Reaberto": "Reabierto",
    "Reabrir": "Reabrir",
    "Reabrir pedido": "Reabrir pedido",
    "Recusado": "Rechazado",
    "Recusar": "Rechazar",
    "Recusar pedido": "Rechazar pedido",
    "Rede (opcional)": "Red (opcional)",
    "Repositório": "Repositorio",
    "Resolveu": "Resolvió",
    "Resolvido.": "Resuelto.",
    "Responda todas as perguntas, na mesma ordem, uma por linha. Se não souber alguma, diga que não sabe: o robô decide sozinho.": "Responda todas las preguntas, en el mismo orden, una por línea. Si no sabe alguna, diga que no sabe: el robot decide solo.",
    "Respostas": "Respuestas",
    "Respostas do suporte": "Respuestas del soporte",
    "Respostas enviadas.": "Respuestas enviadas.",
    "Retomada": "Reanudación",
    "Retomar a sessão no terminal": "Retomar la sesión en la terminal",
    "Robô pegou o pedido": "El robot tomó el pedido",
    "Rode este SQL no banco de produção e confirme.": "Ejecute este SQL en la base de producción y confirme.",
    "Runs": "Runs",
    "Sem SQL de arquivos novos: confira o diff.": "Sin SQL de archivos nuevos: revise el diff.",
    "Sem eventos.": "Sin eventos.",
    "Sem sinal, voltou para a fila": "Sin señal, volvió a la cola",
    "Status alterado": "Estado cambiado",
    "Suporte": "Soporte",
    "Suposições do robô": "Suposiciones del robot",
    "Tempo de Claude": "Tiempo de Claude",
    "URL de referência": "URL de referencia",
    "URL de referência (opcional)": "URL de referencia (opcional)",
    "Urgente": "Urgente",
    "Urgente começa em até 1 minuto; normal, em até 1 hora.": "Urgente empieza en hasta 1 minuto; normal, en hasta 1 hora.",
    "Use quando você conferiu e está tudo certo.": "Úselo cuando haya verificado y todo esté correcto.",
    "Ver no GitHub": "Ver en GitHub",
    "há %{n} d": "hace %{n} d",
    "há %{n} h": "hace %{n} h",
    "há %{n} min": "hace %{n} min",
    "há %{n} s": "hace %{n} s",
    "sem sinal": "sin señal",
};

export default catalogo;
